import {
  AwardLead,
  AwardNominationReviewer,
  GroupLead,
  ProgramCountryLead,
  ProgramCountryNominationReviewer,
  RegionLead,
} from '../../../models';

export enum LeadAssignmentType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum LeadAssignmentInputType {
  Single = 'single',
  Multiple = 'multiple',
}

export type LeadAssignmentLead =
  | AwardLead
  | AwardNominationReviewer
  | GroupLead
  | ProgramCountryLead
  | ProgramCountryNominationReviewer
  | RegionLead;
